import { Flex } from '@shared/components';

import { SummaryStatsCard } from '../summary-stats-card';

export interface SummaryStatsGroupProps {
  duplicationRate: number;
  totalQuestions: number;
  results: {
    total: number;
    totalPassed: number;
  };
}

export default function SummaryStatsGroup(props: Readonly<SummaryStatsGroupProps>) {
  const {
    duplicationRate,
    totalQuestions,
    results: { total: totalQSetResults, totalPassed: totalPassedQSetResults },
  } = props;

  const totalDuplicatedQuestions = Math.ceil((duplicationRate / 100) * totalQuestions);
  const totalFailedQSetResults = totalQSetResults - totalPassedQSetResults;

  return (
    <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
      <SummaryStatsCard
        title='จำนวนชุดข้อสอบทั้งหมด'
        displayValue={`${totalQSetResults} ชุด`}
        additionalInfo={`(${totalQuestions} ข้อ/ชุด)`}
      />
      <SummaryStatsCard
        title='ค่าความซ้ำที่กำหนด'
        displayValue={`${duplicationRate.toFixed(2)}%`}
        additionalInfo={`(${totalDuplicatedQuestions} ข้อ)`}
      />
      <SummaryStatsCard
        title='ผ่านเกณฑ์'
        displayValue={`${totalPassedQSetResults} ชุด`}
        cardColor='success'
      />
      <SummaryStatsCard
        title='ไม่ผ่านเกณฑ์'
        displayValue={`${totalFailedQSetResults} ชุด`}
        cardColor='error'
      />
    </Flex>
  );
}
